"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInvoiceDto = instanceOfInvoiceDto;
exports.InvoiceDtoFromJSON = InvoiceDtoFromJSON;
exports.InvoiceDtoFromJSONTyped = InvoiceDtoFromJSONTyped;
exports.InvoiceDtoToJSON = InvoiceDtoToJSON;
exports.InvoiceDtoToJSONTyped = InvoiceDtoToJSONTyped;
const InvoiceShiftDto_1 = require("./InvoiceShiftDto");
/**
 * Check if a given object implements the InvoiceDto interface.
 */
function instanceOfInvoiceDto(value) {
    if (!('stripeInvoiceId' in value) || value['stripeInvoiceId'] === undefined)
        return false;
    if (!('facilityName' in value) || value['facilityName'] === undefined)
        return false;
    if (!('number' in value) || value['number'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('shifts' in value) || value['shifts'] === undefined)
        return false;
    if (!('totalCost' in value) || value['totalCost'] === undefined)
        return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined)
        return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function InvoiceDtoFromJSON(json) {
    return InvoiceDtoFromJSONTyped(json, false);
}
function InvoiceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'stripeInvoiceId': json['stripeInvoiceId'],
        'facilityName': json['facilityName'],
        'number': json['number'],
        'specialtyCode': json['specialtyCode'],
        'shifts': (json['shifts'].map(InvoiceShiftDto_1.InvoiceShiftDtoFromJSON)),
        'totalCost': json['totalCost'],
        'invoiceDate': (new Date(json['invoiceDate'])),
        'pdfLink': json['pdfLink'] == null ? undefined : json['pdfLink'],
        'dueDate': (json['dueDate'] == null ? null : new Date(json['dueDate'])),
        'status': json['status'],
        'hostedInvoiceUrl': json['hostedInvoiceUrl'] == null ? undefined : json['hostedInvoiceUrl'],
        'periodStart': json['periodStart'] == null ? undefined : (new Date(json['periodStart'])),
        'periodEnd': json['periodEnd'] == null ? undefined : (new Date(json['periodEnd'])),
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'amountRemaining': json['amountRemaining'] == null ? undefined : json['amountRemaining'],
        'subtotal': json['subtotal'] == null ? undefined : json['subtotal'],
        'tax': json['tax'] == null ? undefined : json['tax'],
    };
}
function InvoiceDtoToJSON(json) {
    return InvoiceDtoToJSONTyped(json, false);
}
function InvoiceDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'stripeInvoiceId': value['stripeInvoiceId'],
        'facilityName': value['facilityName'],
        'number': value['number'],
        'specialtyCode': value['specialtyCode'],
        'shifts': (value['shifts'].map(InvoiceShiftDto_1.InvoiceShiftDtoToJSON)),
        'totalCost': value['totalCost'],
        'invoiceDate': ((value['invoiceDate']).toISOString()),
        'pdfLink': value['pdfLink'],
        'dueDate': (value['dueDate'] == null ? null : value['dueDate'].toISOString()),
        'status': value['status'],
        'hostedInvoiceUrl': value['hostedInvoiceUrl'],
        'periodStart': value['periodStart'] == null ? undefined : ((value['periodStart']).toISOString()),
        'periodEnd': value['periodEnd'] == null ? undefined : ((value['periodEnd']).toISOString()),
        'amountPaid': value['amountPaid'],
        'amountRemaining': value['amountRemaining'],
        'subtotal': value['subtotal'],
        'tax': value['tax'],
    };
}
//# sourceMappingURL=InvoiceDto.js.map